import { callPostService } from "../services/api_service";
import { store } from "../../redux/storeConfig/store";
import { dataUtils } from "../js/dataUtils";
import { ValidationManager } from "../validations/validationManager";
import { cloneDeep } from "lodash";
import { applyooConfig } from "../js/applyooConfig";
import React from "react";
import UI_ApplyooIcon from "../components/componentParts/UI_ApplyooIcon";
import { isObjEmpty } from "../../utility/Utils";
import { format } from "date-fns";
import {showToastr} from "../actions/showToastr";
import UI_ApplyooAvatar from "../components/componentParts/UI_ApplyooAvatar";
import {date} from "yup";
import {ApplyooNS, eLogicTypes} from "../applyooConstants";
import {atob} from "buffer";
import {utils_log} from "./utils_log";
import {executeApplyooComponentsFunctionWithReturnValue} from "../infrastructure/useApplyooComponent";
//import {executeApplyooComponentsFunctionWithReturnValue} from "../infrastructure/useApplyooComponent";


export class utils_ui {
    static DateFormatForSave = "yyyy-MM-dd"
    static LongDateFormatForSave = "yyyy-MM-dd HH:mm:ss"
    static C_DomParser = new DOMParser();

    static dicOldFontIcons: any = {
        //        "sticky-note-o": "sticky-note",
        "envelope-o": "envelope-open",
        //        "bell-o": "bell",
        "bank": "university",
        "bar-chart": "chart-bar",
        "pie-chart": "chart-pie",
        "question-circle": "question",
        //        "handshake-o": "handshake",
        "money": "money-bill-alt",
        "diamond": "gem",
        "sign-in": "sign-in-alt",
        "tachometer": "tachometer-alt",
        "cloud-upload": "cloud-upload-alt",
        "refresh": "sync-alt",

    };

    static dicNewFontIcons: any = {
        "fa-tasks": 'fa-list-check',
        //        "sticky-note-o": "sticky-note",
        "fa-envelope-o": "fa-envelope-open",
        //        "bell-o": "bell",
        "fa-bank": "fa-university",
        "fa-bar-chart": "fa-chart-bar",
        "fa-pie-chart": "fa-chart-pie",
        "fa-question-circle": "question",
        //        "handshake-o": "handshake",
        "fa-money": "fa-money-bill-alt",
        "fa-diamond": "fa-gem",
        "fa-sign-in": "fa-sign-in-alt",
        "fa-tachometer": "fa-tachometer-alt",
        "fa-cloud-upload": "fa-cloud-upload-alt",
        "fa-refresh": "fa-sync-alt",

    };

    static nextNewID: any = -1

    static stripHtmlTags = (prmText:any) => {
        let outVal = ""

        if (!!prmText) {
            const regex = /<[^>]+>/gi;
            const stripped = prmText.replace(regex, "");

            if (utils_ui.C_DomParser == undefined) {
                utils_ui.C_DomParser = new DOMParser()
            }

            if (!!utils_ui.C_DomParser) {
                outVal = utils_ui.C_DomParser?.parseFromString(stripped, "text/html").documentElement?.textContent || "";
            }
            else {
                outVal = prmText
            }
        }

        return outVal;
    }

    static setRequiredValidationIfNeeded = (prmCurrElement:any, prmDispatchObj:any) => {
        let dicValidationResponse:any = executeApplyooComponentsFunctionWithReturnValue("getDynamicFieldValidationInfo", {
            prmCurrElement: prmCurrElement
        })

        if (!!dicValidationResponse) {
            for (const currKey in dicValidationResponse) {
                let lstItems:any = dicValidationResponse[currKey]

                if (lstItems?.includes('DynamicValidation_Required')) {
                    let isMandatory:any = dataUtils.getNestedJsonValue(prmCurrElement?.ElementObj,"ExtendedParamsObj.Validations.AP_Validation_Required.IsEnabled")

                    if (!isMandatory) {
                        let modifiedElementObj = {...prmCurrElement}
                        dataUtils.setNestedJsonValue(modifiedElementObj,"ElementObj.ExtendedParamsObj.Validations.AP_Validation_Required.IsEnabled", true, true)
                        prmDispatchObj({type: 'CHANGE_ELEMENT' , commandAction:null, CurrElement: modifiedElementObj})
                    }
                }
            }
        }
    }

    static getNextNewID = () => {
        this.nextNewID--

        return this.nextNewID
    }

    static getTimeInMinutesToDisplay = (prmNumMinutes:any) => {
        let outVal = "--"

        if (prmNumMinutes >= 1) {
            let totalMinutesWithoutSec = parseInt(prmNumMinutes)
            outVal = `${Math.floor(totalMinutesWithoutSec / 60).toString().padStart(2, '0')}:${(totalMinutesWithoutSec % 60).toString().padStart(2, '0')}`

            if (totalMinutesWithoutSec >= 60) {
                outVal = outVal + ' ' + utils_ui.getLanguageTitle("Title_Hours")
            }
            else {
                outVal = outVal + ' ' + utils_ui.getLanguageTitle("Title_Minutes")
            }
        }

        return outVal
    }

    static getTotalMinutes = (prmTimeStr: any) => {
        let outVal: any = null;

        const totalHours = Math.floor(prmTimeStr / 10000);
        let totalMinutes = Math.floor(prmTimeStr / 100 % 100);
        const totalSeconds = Math.floor(prmTimeStr % 100);

        totalMinutes += (totalHours * 60);
        totalMinutes += (totalSeconds / 60);
        outVal = totalMinutes;

        return outVal;
    }

    static getTotalTimeStrJsx = (prmTotalTimeMinutes: any) => {
        let outVal:any = <></>

        if(!!prmTotalTimeMinutes){
            let totalTimeSeconds = 0

            if (!!prmTotalTimeMinutes) {
                totalTimeSeconds += parseInt(prmTotalTimeMinutes) * 60
                totalTimeSeconds += Number((prmTotalTimeMinutes - parseInt(prmTotalTimeMinutes)).toFixed(2)) * 60
                //(dataUtils.getNumberDecimalPart(timeTrackingInfo?.TotalTimeMinutes) * 60)
            }

            const totalHours =  Math.floor(totalTimeSeconds / 3600);
            const totalMinutes = Math.floor(totalTimeSeconds / 60 % 60);
            const totalSeconds = Math.floor(totalTimeSeconds % 60);

            let titleStr = `${utils_ui.getLanguageTitle("Title_Hours")} ${totalHours}, ${utils_ui.getLanguageTitle("Title_Minutes")} ${totalMinutes}, ${utils_ui.getLanguageTitle("Title_Seconds")} ${totalSeconds}`
            outVal = <div title={titleStr} className={['active-time-wrapper d-flex', this.isRtl() ? 'flex-row-reverse' : ''].join(" ")}>
                {
                    !!totalHours && (
                        <>
                            <div className='total-hours'>{totalHours.toString().padStart(2, '0')}</div>
                            <div>:</div>
                        </>
                    )
                }
                {/*<div className='total-hours'>{totalHours.toString().padStart(2, '0')}</div>*/}
                <div className='total-minutes'>{totalMinutes.toString().padStart(2, '0')}</div>
                <div>:</div>
                <div className='total-seconds'>{totalSeconds.toString().padStart(2, '0')}</div>
            </div>

        }


        return outVal
    }

    static setDelay = (prmTimeoutMlSec:number, prmCallbackFunction:any) => {
        const timerID = setTimeout(() => {
            if (!!prmCallbackFunction){
                prmCallbackFunction()
            }

            clearTimeout(timerID)
        }, prmTimeoutMlSec)
    }

    static getBaseFilesUrl = () => {
        let outVal = applyooConfig.baseFilesURL;

        // @ts-ignore
        if (!outVal && !!applyooConfig.API_URL){
            // @ts-ignore
            outVal = applyooConfig.API_URL + "/"
        }

        return outVal;
    }

    static isEmptyDate(prmValue:any) {
        let outVal = true

        if (!!prmValue) {
            try {
                let valueDT = new Date(prmValue)

                if (prmValue.getYear() > 0)
                {
                    outVal = false
                }
            }
            catch (e) {
                //DO Nothing
            }
        }

        return outVal
    }

    static createHeaderFiltersDataSource = (prmData:any, prmFieldName:string, prmRepositoryList?:any) => {
        let lstOut:any = [];
        let dicValue:any = {};
        let dicRepositoryList:any
        let newObj:any = {}

        if (!!prmData) {
            if(!!prmRepositoryList) {
                dicRepositoryList = dataUtils.convertArrayToDicObject(prmRepositoryList,"value")
            }

            for (const currRowData of prmData) {
                let currColumData = currRowData[prmFieldName]

                if (!!currColumData) {
                    if (!!dicRepositoryList &&  !!dicRepositoryList[currColumData]) {
                        newObj = {
                            value:dicRepositoryList[currColumData]?.value,
                            text:dicRepositoryList[currColumData]?.text
                        }
                    }
                    else {
                        newObj = {
                            value:currColumData,
                            text:currColumData
                        }
                    }

                    if( !dicValue[newObj?.value]) {
                        dicValue[newObj?.value] = newObj
                        lstOut.push(newObj)
                    }
                }
            }
        }

        return lstOut;
    }

    static isRtl = () => {
        let outVal = store.getState().layout?.isRTL;

        return outVal;
    }

    static getUniqueArrayValues = (prmArray: any) => {
        let lstOut:any = []

        for (const currItem of prmArray) {
            if (!lstOut.includes(currItem)) {
                lstOut.push(currItem)
            }
        }

        return lstOut
    }

    static isElementConditionTrue = (prmConditionObj:any) => {
        let outVal = false

        if (!!prmConditionObj) {
            let dataBindStr:any = null
            let currParamValue:any = null;

            switch (prmConditionObj.Source) {
                case "element":
                    let elementObj = dataUtils.getElementByClientID(prmConditionObj.ClientID);

                    if (!!elementObj) {
                        dataBindStr = elementObj?.DataBindStr;
                    }
                    break;

                case "dataBind":
                    dataBindStr = prmConditionObj.DataBindStr;
                    break;

                case "value":
                    currParamValue = dataUtils.convertValueToType(prmConditionObj.Value,prmConditionObj.ValueType); //currParam.ParamValue;
                    break;

                case "UserRole":
                    let lstConditionsRoles:any = prmConditionObj?.arrEndUserRoles?.filter((prmItem:any) => {return prmItem.isSelected})
                                                                                .map((prmItem:any) => {return prmItem.RoleCode})
                    let dicUserRolePermission:any = store.getState().store_userData?.userDetailsObj?.DicUserRolePermission

                    for (const currRoleCode in dicUserRolePermission) {
                        if (lstConditionsRoles.includes(currRoleCode)) {
                            outVal = true
                            break;
                        }
                    }

                    break;

                default:
                    currParamValue =dataUtils.convertValueToType(prmConditionObj.Value,prmConditionObj.ValueType);
            }

            if (!!dataBindStr) {
                currParamValue = utils_ui.getDataItem(dataBindStr);

                if (!!currParamValue
                    && !dataUtils.isNativeProperty(currParamValue)) {
                    currParamValue = JSON.stringify(currParamValue);
                }
            }

            if (currParamValue != undefined && currParamValue != null) {
                switch (prmConditionObj.OperatorID) {
                    case eLogicTypes.Equals :
                        outVal = !!currParamValue
                        break;
                    case eLogicTypes.NotEquals :
                        outVal = !currParamValue
                        break;

                }
            }


            //outVal = !!currParamValue
            //paramsDic[currParam.ParamName] = currParamValue;

        }

        return outVal
    }

    static getModifiedFields = (prmOriginObj:any, prmTagetObj:any, prmLstFields:any) => {

        let lstOut:any = [];

        for (let key in prmOriginObj) {
            if (prmLstFields == undefined || prmLstFields == null || prmLstFields.indexOf(key) > -1) {
                if (!prmOriginObj[key] && !prmTagetObj[key]) {//Comment: both null
                    continue;
                }
                else if ((!!prmOriginObj[key] && !prmTagetObj[key])
                    || (!prmOriginObj[key] && !!prmTagetObj[key])) {//Comment: one is null and the other is not
                    lstOut.push(key)
                    // break;
                }
                    // else if ((!prmOriginObj[key] && prmTagetObj[key])
                    //             || (prmOriginObj[key] && !prmTagetObj[key])) {//Comment: one null and the other one not null
                    //
                    //     outVal = true;
                    //     break;
                // }
                else if (this.isNativeProperty(prmOriginObj[key])
                    && prmOriginObj[key] != prmTagetObj[key]) {//Comment: is native and different
                    lstOut.push(key)

                    // outVal = true;
                    // break;
                }
                else if (prmOriginObj[key] instanceof Date
                    && prmOriginObj[key].toString() != prmTagetObj[key].toString()) {//Comment: is date and different
                    lstOut.push(key)
                    // outVal = true;
                    // break;
                }
                else if (Array.isArray(prmOriginObj[key]) && Array.isArray(prmTagetObj[key])) {//Comment: are arrays different
                    if (JSON.stringify(prmOriginObj[key]) != JSON.stringify(prmTagetObj[key])) {
                        lstOut.push(key)
                        // outVal = true;
                        // break;
                    }
                }
            }
        }

        return lstOut;

    }

    static isObjModified = (prmOriginObj:any, prmTagetObj:any, prmLstFields:any) => {

        let outVal = false;

        for (let key in prmOriginObj) {
            if (prmLstFields == undefined || prmLstFields == null || prmLstFields.indexOf(key) > -1) {
                if (!prmOriginObj[key] && !prmTagetObj[key]) {//Comment: both null
                    continue;
                }
                else if ((!!prmOriginObj[key] && !prmTagetObj[key])
                    || (!prmOriginObj[key] && !!prmTagetObj[key])) {//Comment: one is null and the other is not
                    utils_log.writeObjectToLog("isObjModified",prmOriginObj,`${key} - original: ${prmOriginObj[key]} , actual: ${prmTagetObj[key]}`)
                    outVal = true;
                    break;
                }
                    // else if ((!prmOriginObj[key] && prmTagetObj[key])
                    //             || (prmOriginObj[key] && !prmTagetObj[key])) {//Comment: one null and the other one not null
                    //
                    //     outVal = true;
                    //     break;
                // }
                else if (this.isNativeProperty(prmOriginObj[key])
                    && prmOriginObj[key] != prmTagetObj[key]) {//Comment: is native and different
                    utils_log.writeObjectToLog("isObjModified",prmOriginObj,`${key} - original: ${prmOriginObj[key]} , actual: ${prmTagetObj[key]}`)
                    outVal = true;
                    break;
                }
                else if (prmOriginObj[key] instanceof Date
                    && prmOriginObj[key].toString() != prmTagetObj[key].toString()) {//Comment: is date and different
                    utils_log.writeObjectToLog("isObjModified",prmOriginObj,`${key} - original: ${prmOriginObj[key]} , actual: ${prmTagetObj[key]}`)
                    outVal = true;
                    break;
                }
                else if (Array.isArray(prmOriginObj[key]) && Array.isArray(prmTagetObj[key])) {//Comment: are arrays different
                    if (JSON.stringify(prmOriginObj[key]) != JSON.stringify(prmTagetObj[key])) {
                        utils_log.writeObjectToLog("isObjModified",prmOriginObj,`${key} - original: ${prmOriginObj[key]} , actual: ${prmTagetObj[key]}`)
                        outVal = true;
                        break;
                    }
                }
            }
        }

        return outVal
    }

    static isNativeProperty =  (prmProperty:any) => {
        let outVal = false;

        if (typeof prmProperty == "string"
            || typeof prmProperty == "number"
            || typeof prmProperty == "boolean") {
            outVal = true;
        }

        return outVal;
    }

    static  isElementRelatedToConditionalData = (prmElementObj: any) => {
        let outVal = false;

        if (!!prmElementObj?.ExtendedParamsObj?.IsVisible?.arrConditions) {
            for (const currConditionObj of prmElementObj?.ExtendedParamsObj?.IsVisible?.arrConditions) {
                if (currConditionObj.Source == "element" || currConditionObj.Source == "dataBind") {
                    outVal = true
                    break
                }
            }

            if (!outVal
                && !!prmElementObj?.ExtendedParamsObj?.IsReadOnly?.arrConditions
                && Array.isArray(prmElementObj?.ExtendedParamsObj?.IsReadOnly?.arrConditions)) {
                for (const currConditionObj of prmElementObj?.ExtendedParamsObj?.IsReadOnly?.arrConditions) {
                    if (currConditionObj.Source == "element" || currConditionObj.Source == "dataBind") {
                        outVal = true
                        break
                    }
                }
            }
        }

        return outVal
    }

    static isElementVisible = (prmElementObj: any) => {
        let outVal = true;

        if (!!prmElementObj) {
            if (!prmElementObj.IsVisible) {
                outVal = false;
            }

            if (!!prmElementObj?.ExtendedParamsObj?.IsVisible?.arrConditions) {
                for (const currConditionObj of prmElementObj?.ExtendedParamsObj?.IsVisible?.arrConditions) {
                    let isTrue = this.isElementConditionTrue(currConditionObj)

                    if (!isTrue) {
                        if (!!currConditionObj.caseElseSetValue) {
                            outVal = dataUtils.convertValueToType(currConditionObj.caseElseSetValue,"boolean");
                        }
                        break;
                    }
                    else {
                        if (!!currConditionObj.setValue) {
                            outVal = dataUtils.convertValueToType(currConditionObj.setValue,"boolean");
                        }
                    }
                }
            }
        }

        return outVal
    }

    static getDummyUIElement = (prmElementGuid: string, prmElementTypeCode: string) => {
        let outObj = {
            ElementGuid: prmElementGuid,
            ElementObj: {
                ElementGuid: prmElementGuid,
                IsVisible: true,
            },
            ElementTypeCode: prmElementTypeCode,
            ElementType: "",
            DropElementTypes: [],
            SubItems: []
        }

        return outObj
    }
    static showToaster = (prmText:any, prmTypeCode:string, prmOnClickInfo?:any) =>{
        let toasterObj = new showToastr({});
        let ActionParameters = {
                ToastrType: prmTypeCode, //'succeed',
                ToastrMessage: <div>{utils_ui.getLanguageTitle(prmText)}</div>,
                OnClickInfo: prmOnClickInfo,
            };
        toasterObj.Execute(ActionParameters, null,null)


        // let outJsx = <div>
        //     <UI_ApplyooTitle title={prmText}/>
        // </div>
        //
        // toast.info(outJsx, {
        //     position: "top-center",
        //     autoClose: 5000,//false,
        //     closeOnClick: true,
        //     pauseOnHover: false,
        //     draggable: false,
        //     progress: undefined,
        //     hideProgressBar: true});
    }

    static convertDateFromOADate(prmOADate:any){
        let days = parseInt(prmOADate);
        // Treat decimal part as part of 24hr day, always +ve
        let ms = Math.abs((prmOADate - days) * 8.64e7);
        // Add days and add ms
        let outVal = new Date(1899, 11, 30 + days, 0, 0, 0, ms);

        return outVal
    }

    // Convert an ECMAScript Date to a Microsoft OADate
    // static convertDateToOADate(prmDate:any){
    //     let tempDT:date = new Date(prmDate);
    //     // Set temp to start of day and get whole days between dates,
    //     let days:any = Math.round((tempDT.setHours(0,0,0,0) - new Date(1899, 11, 30)) / 8.64e7);
    //     // Get decimal part of day, OADate always assumes 24 hours in day
    //     let partDay = (Math.abs((date - tempDT) % 8.64e7) / 8.64e7).toFixed(10);
    //
    //     return days + partDay.substr(1);
    // }

    static getFormatedNumberStr(prmValue:any, prmNumDecimalPoints?:any) {
        let outVal = ""

        if (!!prmValue){
            if (prmNumDecimalPoints == undefined){
                outVal = prmValue.toLocaleString()
            }
            else {
                let strNum = prmValue.toFixed(prmNumDecimalPoints)
                outVal = parseFloat(strNum).toLocaleString()
            }
        }

        return outVal
    }

    static  getFormatedValueStr(prmValue:any, prmFormatedStr: any) {
        let outVal = prmValue

        if (prmValue instanceof Date) {
            if (!prmFormatedStr || prmFormatedStr == "ShortDate") {
                prmFormatedStr = utils_ui.getLanguageTitle('Settings_ShortDateFormat')
            }

            outVal = utils_ui.getFormatedDateStr(prmValue, prmFormatedStr)
        }
        else if (!!dataUtils.isNumeric (prmValue)) {
            outVal = utils_ui.FormatNumber(prmValue, prmFormatedStr)
        }

        return outVal
    }

    static getFormatedDateStr(prmDate: any, prmFormatStr: string) {
        let outVal = ""

        try {
            if (!!prmDate && !!prmFormatStr) {
                outVal = format(prmDate, prmFormatStr)
            }
        }
        catch (ex) {
            console.log(ex)
        }

        return outVal
    }

    static getTaskStatusDropDownItemJSX(prmItem:any) {
        let outJSX = {
                ...prmItem,
                    text: utils_ui.getLanguageTitle(dataUtils.parseLangKey(prmItem?.row?.AP_LangKey)),
                    label: (
                    <div className={[prmItem.row?.CssClasses, "drop-downXXX task-status-label d-flex align-items-center gap-25 justify-content-center"].join(" ")}>
                        <UI_ApplyooIcon iconStr={prmItem.row?.IconCssStr} />
                        {utils_ui.getLanguageTitle(dataUtils.parseLangKey(prmItem?.row?.AP_LangKey))}
                    </div>
                )}

        return outJSX
    }

    static isNumericValue(prmValue:any){
        let outVal = false

        if (typeof prmValue === 'number' && !isNaN(prmValue) && prmValue !== Infinity) {
            outVal = true
        }

        return outVal
    }

    static getListItemsByElement(prmElementObj: any, prmIsRemoveNull: boolean) {
        let lstItems = [];

        if (prmElementObj) {
            if (prmElementObj?.ExtendedParamsObj?.ListOfValuesType
                && prmElementObj?.ExtendedParamsObj.ListOfValuesType == "static"
                && prmElementObj?.ExtendedParamsObj?.ListOfValuesValue) {
                lstItems = prmElementObj?.ExtendedParamsObj?.ListOfValuesValue?.map((prmItem:any) => {
                    let outObj = {
                        value: prmItem.value,
                        text: prmItem.text,
                        label: prmItem.text,
                    }

                    return outObj
                });
            }
            else if (prmElementObj?.ListOfValues) {
                const currRepoName = prmElementObj?.ListOfValues;

                if (store.getState().store_Repositories.dicRepositoryItemsForKeyValue[currRepoName]) {
                    lstItems = [...store.getState().store_Repositories.dicRepositoryItemsForKeyValue[currRepoName]];
                }
            }

            if (prmElementObj?.ExtendedParamsObj?.ListOfValuesValue_Filter && lstItems.length > 0) {
                try {
                    lstItems = lstItems.filter(function (prmItem: any) {

                        return eval(prmElementObj.ExtendedParamsObj.ListOfValuesValue_Filter);
                    });
                }
                catch (ex) {
                    console.log(ex)
                }
            }

            if (prmIsRemoveNull) {
                lstItems = lstItems.filter((prmItem: any) => {
                    return prmItem.value !== null
                })
            }

            if (prmElementObj.ExtendedParamsObj?.ListOfValues_IsAddEmptyValue && lstItems && lstItems.length > 0) {
                let obj = {
                    value: prmElementObj.ExtendedParamsObj.ListOfValues_EmptyValueKey,
                    text: prmElementObj.ExtendedParamsObj.ListOfValues_EmptyValueText,
                    label: prmElementObj.ExtendedParamsObj.ListOfValues_EmptyValueText,
                }

                if (prmElementObj.ExtendedParamsObj.ListOfValues_EmptyValuePosition === 'first') {
                    lstItems.unshift(obj);
                }
                else {
                    lstItems.push(obj);
                }

            }
        }

        return lstItems;
    }

    static getViewType() {
        let outVal = "desktop-view";

        if (window.innerWidth <= 700) {
            outVal = "mobile-view";
        }
        else if (window.innerWidth <= 1365) {
            outVal = "tablet-view";
        }

        return outVal;
    }

    static isMobileView() {
        let outVal = false;
        //1365
        if (window.innerWidth < 1024) {
            outVal = true;
        }
        // if(window.innerWidth <= 700){
        //     outVal = true;
        // }

        return outVal;
    }

    static isITabletView() {
        let outVal = false;
        //1365
        if (window.innerWidth >= 1024 && window.innerWidth <= 1200) {
            outVal = true;
        }
        // if(window.innerWidth <= 700){
        //     outVal = true;
        // }

        return outVal;
    }

    static getRepositoryObj(prmListName: string, prmValue: any) {
        let outVal = {};
        let dicRepositoryItems = store.getState().store_Repositories.dicRepositoryItemsForKeyValue;

        if (!!dicRepositoryItems[prmListName]) {
            let currRepoItem = dicRepositoryItems[prmListName].find((prmItem: any) => {
                return prmItem.value == prmValue;
            });

            if (!!currRepoItem) {
                outVal = currRepoItem;
            }
        }

        return outVal;
    }

    static getRepositoryDisplayText(prmListName: string, prmValue: any) {
        let outVal = "";
        let dicRepositoryItems = store.getState().store_Repositories.dicRepositoryItemsForKeyValue;

        if (!!dicRepositoryItems[prmListName]) {
            let currRepoItem = dicRepositoryItems[prmListName].filter((prmItem: any) => {
                return prmItem.value == prmValue;
            })[0];

            if (!!currRepoItem) {
                outVal = currRepoItem.text;
            }
        }

        return outVal;
    }

    static createDropDownItemsFromList(prmList: any, prmKeyFieldName: any, prmDisplayFieldName: any, prmImageFieldName?: any) {
        let lstOut = [];
        let clonedList = cloneDeep(prmList)

        lstOut = clonedList?.map((prmItem: any) => {
            let value = prmItem[prmKeyFieldName]
            let displayText = this.getLanguageTitle(prmItem[prmDisplayFieldName])
            let labelJsx: any = displayText

            if (!!prmImageFieldName) {
                let imageValue = "";

                if (!!prmItem?.hasOwnProperty(prmImageFieldName)) {
                    imageValue = prmItem[prmImageFieldName]
                }
                else if (!!prmItem?.row?.hasOwnProperty(prmImageFieldName)) {
                    imageValue = prmItem.row[prmImageFieldName]
                }

                if (!!prmImageFieldName) {
                    labelJsx =
                        <div className={[prmItem.row?.CssClasses, "d-flex drop-down align-items-center"].join(" ")}>
                            <div className='mr-50 ml-50'>
                                {!!imageValue ?
                                    <img className='image-in-drop-down-list' loading="lazy" src={`${utils_ui.getBaseFilesUrl()}${imageValue}`} />
                                    :
                                    <UI_ApplyooAvatar title={prmItem.label || displayText} initials={true} />
                                    // <UI_ApplyooIcon iconStr='circle' />
                                }
                            </div>

                            {displayText}
                        </div>
                }

            }

            return {
                ...prmItem,
                value: value,
                label: labelJsx,
                text: displayText
            }
        })
        return lstOut
    }
    static getRepositoryProperty(prmListName: string, prmValue: any, prmFieldName: string) {
        let outVal = null;
        let dicRepositoryItems = store.getState().store_Repositories.dicRepositoryItemsForKeyValue;

        if (!!dicRepositoryItems[prmListName]) {
            let currRepoItem = dicRepositoryItems[prmListName].filter((prmItem: any) => {
                return prmItem.value == prmValue;
            })[0];

            if (!!currRepoItem && !!currRepoItem.row && !!currRepoItem.row[prmFieldName]) {
                outVal = currRepoItem.row[prmFieldName];
            }
        }

        return outVal;
    }

    static stripHtmlText(prmHtmlContent:any) {
        let outStr = ""

        try {
            let tmp = document.createElement("DIV");

            tmp.innerHTML = prmHtmlContent;

            outStr = tmp.textContent || tmp.innerText || "";
        }
        catch (ex)
        {

        }

        return outStr
    }

    static getNumericValue(prmValue:any,prmDefaultValue:any) {
        let outVal = prmDefaultValue;

        if (!!prmValue && dataUtils.isNumeric(prmValue)) {
            outVal = parseFloat(prmValue)
        }

        return outVal;
    }

    static convertAllDatesToUTCStr(prmData: any) {
        if (!!prmData) {
            for (const currKey in prmData) {
                if (!!prmData[currKey]
                    && (prmData[currKey].constructor.toString().toLowerCase().includes("date"))) {
                    prmData[currKey] = prmData[currKey].toUTCString();
                } else if (typeof prmData[currKey] === 'object'
                    && !Array.isArray(prmData[currKey]) &&
                    prmData[currKey] !== null) {
                    prmData[currKey] = this.convertAllDatesToUTCStr(prmData[currKey]);
                } else if (Array.isArray(prmData[currKey])
                    && prmData[currKey].length > 0) {
                    for (let ind01 = 0; ind01 < prmData[currKey].length; ind01++) {
                        prmData[currKey][ind01] = this.convertAllDatesToUTCStr(prmData[currKey][ind01]);
                    }
                }
            }
        }

        return prmData;
    }

    static parseDateField(prmValue:any) {
        let outVal = null;
        let datePatternFromCSharp = /T(\d{2})([:])(\d{2})([:])(\d{2})([.])(\d{7})$/

        if (!!prmValue){
            if (!!prmValue
                && (typeof prmValue === 'string' || prmValue instanceof String)
                && prmValue.startsWith("/Date(")) {
                outVal = new Date(parseInt(prmValue.substr(6)));

            } else if (typeof prmValue === 'object'
                && !Array.isArray(prmValue) &&
                prmValue !== null) {
                outVal = this.parseAllDates(prmValue);

            } else if (Array.isArray(prmValue)
                && prmValue.length > 0) {
                for (let ind01 = 0; ind01 < prmValue.length; ind01++) {
                    prmValue[ind01] = this.parseAllDates(prmValue[ind01]);
                }
            }
            else if (!!prmValue
                && datePatternFromCSharp.test(prmValue)){
                outVal = new Date(prmValue);
            }
        }

        return outVal;
    }

    static isPrimitive(prmValue:any) {
        let outVal = prmValue === null ||
            typeof prmValue === "string" ||
            typeof prmValue === "number" ||
            typeof prmValue === "boolean" ||
            typeof prmValue === "undefined" ||
            typeof prmValue === "symbol" ||
            typeof prmValue === "bigint"

        return outVal;
    }

    static parseAllDates(prmData: any, prmLstSpecificProperties?: any, prmLstIgnoredProperties?: any) {
        let datePatternFromCSharp = /T(\d{2})([:])(\d{2})([:])(\d{2})([.])(\d{7})$/
        let datePatternFromIso8601 = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d)/
        let datePatternFromCSharp2 = /^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})$/
        let datePatternFromCSharpWith3DigitFraction = /T(\d{2})([:])(\d{2})([:])(\d{2})([.])(\d{3})$/
        let datePatternFromCSharpWithoutTime = /T(\d{2})([:])(\d{2})([:])(\d{2})$/
        let datePatternFromCSharpWithTime = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z)$/
        let datePatternForStrDate_ddMMyy = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/[0-9]{4} ([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/

        if (!!prmData) {
            if (Array.isArray(prmData)){
                for (let currRow of prmData) {
                    currRow = this.parseAllDates(currRow,prmLstSpecificProperties,prmLstIgnoredProperties)
                }
            }
            else {
                for (const currKey in prmData) {
                    if ((!!prmLstIgnoredProperties && prmLstIgnoredProperties.length > 0 && prmLstIgnoredProperties.includes(currKey))
                        || (!!prmLstSpecificProperties && prmLstSpecificProperties.length > 0 && !prmLstIgnoredProperties.includes(currKey))){
                        continue;
                    }

                    if (!!prmData[currKey]
                        && (typeof prmData[currKey] === 'string' || prmData[currKey] instanceof String)
                        && prmData[currKey].startsWith("/Date(")) {
                        prmData[currKey] = new Date(parseInt(prmData[currKey].substr(6)));

                    } else if (typeof prmData[currKey] === 'object'
                        && !Array.isArray(prmData[currKey]) &&
                        prmData[currKey] !== null) {
                        prmData[currKey] = this.parseAllDates(prmData[currKey]);

                    } else if (Array.isArray(prmData[currKey])
                        && prmData[currKey].length > 0) {
                        for (let ind01 = 0; ind01 < prmData[currKey].length; ind01++) {
                            prmData[currKey][ind01] = this.parseAllDates(prmData[currKey][ind01]);
                        }
                    }
                    else if (!!prmData[currKey]
                            && (typeof prmData[currKey] === 'string' || prmData[currKey] instanceof String)
                        && prmData[currKey].startsWith("{")) {
                        let tempObj = dataUtils.parseData(prmData[currKey])

                        if (!!tempObj && !this.isObjEmpty(tempObj)) {
                            continue
                        }
                        //
                    }
                    else if (!!prmData[currKey]
                        && prmData[currKey].toString().length < 30
                        && datePatternFromIso8601.test(prmData[currKey])){
                        prmData[currKey] = new Date(prmData[currKey]);
                    }
                    else if (!!prmData[currKey]
                        && prmData[currKey].toString().length < 30
                        && datePatternFromCSharp.test(prmData[currKey])){
                        prmData[currKey] = new Date(prmData[currKey]);
                    }
                    else if (!!prmData[currKey]
                        && prmData[currKey].toString().length < 30
                        && datePatternFromCSharp2.test(prmData[currKey])){
                        prmData[currKey] = new Date(prmData[currKey]);
                    }
                    else if (!!prmData[currKey]
                        && prmData[currKey].toString().length < 30
                        && datePatternFromCSharpWithoutTime.test(prmData[currKey])){
                        prmData[currKey] = new Date(prmData[currKey]);
                    }
                    else if (!!prmData[currKey]
                        && prmData[currKey].toString().length < 30
                        && datePatternFromCSharpWithTime.test(prmData[currKey])){
                        prmData[currKey] = new Date(prmData[currKey]);
                    }
                    else if (!!prmData[currKey]
                        && prmData[currKey].toString().length < 30
                        && datePatternFromCSharpWith3DigitFraction.test(prmData[currKey])){
                        prmData[currKey] = new Date(prmData[currKey]);
                    }
                    else if (!!prmData[currKey]
                        && prmData[currKey].toString().length < 30
                        && datePatternForStrDate_ddMMyy.test(prmData[currKey])){
                        let dateStr = prmData[currKey]
                        prmData[currKey] = new Date(dateStr.substring(6,10),parseInt(dateStr.substring(3,5)) - 1,dateStr.substring(0,2),dateStr.substring(11,13),dateStr.substring(14,16));
                    }
                }
            }

        }

        return prmData;

    }

    static parseDate(prmStrValue: any) {
        if (!!prmStrValue) {
            if (!!prmStrValue
                && (typeof prmStrValue === 'string' || prmStrValue instanceof String)) {
                // && prmStrValue.startsWith("/Date(")) {
                let datePatternFromCSharp = /T(\d{2})([:])(\d{2})([:])(\d{2})([.])(\d{7})$/
                let datePatternFromCSharpWith3DigitFraction = /T(\d{2})([:])(\d{2})([:])(\d{2})([.])(\d{3})$/
                let datePatternFromCSharpWithoutTime = /T(\d{2})([:])(\d{2})([:])(\d{2})$/
                let datePatternFromCSharpWithTime = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z)$/
                let datePatternForStrDate_ddMMyy = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/[0-9]{4} ([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/

                if (!!prmStrValue
                    && datePatternFromCSharp.test(prmStrValue.toString())){
                    prmStrValue = new Date(prmStrValue.toString());
                }
                else if (!!prmStrValue
                    && datePatternFromCSharpWithoutTime.test(prmStrValue.toString())){
                    prmStrValue = new Date(prmStrValue.toString());
                }
                else if (!!prmStrValue
                    && datePatternFromCSharpWith3DigitFraction.test(prmStrValue.toString())){
                    prmStrValue = new Date(prmStrValue.toString());
                }
                else if (!!prmStrValue
                    && datePatternFromCSharpWithTime.test(prmStrValue.toString())){
                    prmStrValue = new Date(prmStrValue.toString());
                }
                else if (!!prmStrValue
                    && datePatternFromCSharpWith3DigitFraction.test(prmStrValue.toString())){
                    prmStrValue = new Date(prmStrValue.toString());
                }
                else if (!!prmStrValue
                    && datePatternForStrDate_ddMMyy.test(prmStrValue.toString())){
                    let dateStr = prmStrValue.toString()
                    prmStrValue = new Date(parseInt(dateStr.substring(6,10)),parseInt(dateStr.substring(3,5)) - 1,parseInt(dateStr.substring(0,2)),parseInt(dateStr.substring(11,13)),parseInt(dateStr.substring(14,16)));
                }

                //prmStrValue = new Date(parseInt(prmStrValue.substr(6)));
            }
        }

        return prmStrValue;

    }

    static getFirstPageElementByTypeCode(prmElementTypeCode:string){
        let outObj = null;

        let lstElements = store.getState().store_PageStructure.lstElementsFlat;

        if (!!lstElements){
            outObj = lstElements.find((prmItem:any) => {
                return prmItem.ElementTypeCode == prmElementTypeCode
            })
        }

        return outObj
    }

    static getDicFilterValues(prmResponseName?: string) {

        //let currPageStruct = store.getState().store_PageStructure.pageStructure;
        let currPageData = store.getState().store_PageData.data;
        let currPageStruct = store.getState().store_PageStructure.pageStructure;

        const queryParams = new URLSearchParams(window.location.search);
        //const urlParamsObj = useParams();
        let dicFilterValues: { [id: string]: any; } = {};
        if (!!currPageStruct && !!currPageStruct.LstDataRequests) {
            for (let ind01 = 0; ind01 < currPageStruct.LstDataRequests.length; ind01++) {
                let currDataRequestObj = currPageStruct.LstDataRequests[ind01];

                if (prmResponseName == "*"
                    || currDataRequestObj.ResponseName == prmResponseName) {

                    if (!!currDataRequestObj && !!currDataRequestObj.LstFilterElements) {

                        for (let ind02 = 0; ind02 < currDataRequestObj.LstFilterElements.length; ind02++) {
                            let currFilterObj = currDataRequestObj.LstFilterElements[ind02];

                            if (!!currFilterObj.DataBindStr
                                && (!prmResponseName
                                    || (!!prmResponseName && currFilterObj.DataBindStr.startsWith(`Filters.${prmResponseName}`))
                                )
                            ) {
                                if (currFilterObj.FilterValueSource == 'url'
                                    && !!currFilterObj.ConstValue) {

                                    let currUrlParam = queryParams.get(currFilterObj.ConstValue); //urlParamsObj; //this.locationObj.search();

                                    //comment: handle ???
                                    // if (!!currPrimaryEntityID
                                    //     && currPrimaryEntityID != "0"
                                    //     && currUrlParam == "0"
                                    //     && currFilterObj.ConstValue.toLowerCase() == "rowid"){
                                    //     currUrlParam = currPrimaryEntityID
                                    // }

                                    if (!!currUrlParam) {

                                        let currFilterValue = {
                                            DataRequestParamID: currFilterObj.DataRequestParamID,
                                            Value: currUrlParam
                                        };

                                        dicFilterValues[currFilterValue.DataRequestParamID] = currFilterValue;
                                    }
                                    else {
                                        let currValue = dataUtils.getNestedJsonValue(currPageData, currFilterObj.DataBindStr);

                                        if (!!currValue){
                                            let currFilterValue = {
                                                DataRequestParamID: currFilterObj.DataRequestParamID,
                                                Value: currValue,
                                                DataBindStr: currFilterObj.DataBindStr,
                                            };

                                            dicFilterValues[currFilterValue.DataBindStr] = currFilterValue;
                                        }
                                    }
                                }
                                else if (currFilterObj.FilterValueSource == 'element') {
                                    let currFilterValue = {
                                        DataRequestParamID: currFilterObj.DataRequestParamID,
                                        Value: dataUtils.getNestedJsonValue(currPageData, currFilterObj.DataBindStr),
                                        DataBindStr: currFilterObj.DataBindStr,
                                    };

                                    if (!!currFilterValue.Value
                                        && Object.keys(currFilterValue.Value).length === 0
                                        && currFilterValue.Value.constructor === Object) { //&& Object.keys(ESLNS.dataUtils.getNestedJsonValue(this.scopeObj.Data, currPageElement.DataBindStr)).length == 0) {
                                        currFilterValue.Value = undefined;
                                    }
                                    else if (Array.isArray(currFilterValue.Value)
                                        && currFilterValue.Value.length == 1
                                        && currFilterValue.Value[0] == null) {
                                        currFilterValue.Value = undefined;
                                    }
                                    else if (Array.isArray(currFilterValue.Value)
                                        && currFilterValue.Value.length == 0) {
                                        currFilterValue.Value = undefined;
                                    }

                                    if (currFilterValue?.Value != undefined
                                    && currFilterValue?.Value != null){
                                        dicFilterValues[currFilterValue.DataBindStr] = currFilterValue;
                                    }
                                }
                            }

                        }
                    }

                }
            }
        }
        return dicFilterValues;
    }

    static addIsSelectedColumnToDataArray(prmLstData: any, prmIsClone: boolean = true, prmDefaultValue: any = false) {
        let lstOut = null;

        if (prmIsClone) {
            lstOut = cloneDeep(prmLstData);
        } else {
            lstOut = prmLstData;
        }

        if (!!lstOut) {
            for (let ind01 = 0; ind01 < lstOut.length; ind01++) {
                let currItem = lstOut[ind01];
                currItem.isSeleced = prmDefaultValue;
            }
        }

        return lstOut;
    }

    static parseSystemValue(prmValue: any) {
        let outVal = prmValue;

        if (prmValue.startsWith("@")) {
            let currVarName = prmValue.substring(1);

            outVal = dataUtils.getNestedJsonValue(store.getState().store_PageData.data, currVarName)
        }

        return outVal;
    }

    static getStaticFileUrl(prmAssetUrl: string) {
        let outVal = utils_ui.getBaseFilesUrl() + prmAssetUrl;

        return outVal;
    }

    static setLanguageTitles(prmDicTitles: any) {
        //@ts-ignore
        let currTitles = ApplyooNS.dicCurrentLanguageTitles || {}
        currTitles = { ...currTitles, ...prmDicTitles };
        ApplyooNS.dicCurrentLanguageTitles = currTitles;
    }

    static addServerUrlSuffixIfMissing(prmUrl:string) {
        let outVal = prmUrl;

        if (!!outVal && !outVal.startsWith("http")) {
            outVal = utils_ui.removeDoubleSlashFromUrl(`${utils_ui.getBaseFilesUrl()}/${outVal}`)
        }

        return outVal
    }

    static deleteObjectProperties(prmObj:any, prmLstIgnoredKeys?:any) {
        if (prmObj !== null) {
            for (const currKey in prmObj) {
                if (typeof prmObj[currKey] === 'object' && prmObj[currKey] !== null) {
                    utils_ui.deleteObjectProperties(prmObj[currKey]);
                }

                if (!prmLstIgnoredKeys || !prmLstIgnoredKeys.includes(currKey)) {
                    delete prmObj[currKey]
                }
            }
        }
    }

    static calcContainerWidthByClassName(prmClassName:string, prmMinWidth:number, prmSidesMargin:number, prmIsAddPX:boolean) {
        let outVal:any = ''
        let calcWidth:number = prmMinWidth

        let domContainerObj = document.getElementsByClassName(prmClassName)[0]
        if (!!domContainerObj) {
            let domContainerSize = domContainerObj.getBoundingClientRect();

            calcWidth = domContainerSize.width - prmSidesMargin
        }

        if (prmIsAddPX) {
            outVal = `${calcWidth}px`
        }
        else {
            outVal = calcWidth
        }

        return outVal
    }

    static getLanguageTitle(prmTitle: string) {
        let outVal = prmTitle || "";
        //@ts-ignore

        // let dicTitles: any = ApplyooNS.dicCurrentLanguageTitles;

        if (!!prmTitle
                && !isObjEmpty(ApplyooNS.dicCurrentLanguageTitles)
                && !!ApplyooNS.dicCurrentLanguageTitles[prmTitle]) {
            outVal = ApplyooNS.dicCurrentLanguageTitles[prmTitle]
        }

        return outVal;
    }

    static setDataItem(prmDataBindStr: any, prmData: any, prmIsCreateNestedObjects: boolean = true) {
        let dataBindStr = prmDataBindStr;

        if (!!prmDataBindStr && prmDataBindStr.startsWith("FreeBinding.")) {
            dataBindStr = prmDataBindStr.substring("FreeBinding.".length);
        }
        // let currPageData = store.getState().store_PageData.data;

        // dataUtils.setNestedJsonValue(currPageData, dataBindStr, prmData, prmIsCreateNestedObjects);

        store.dispatch({ type: "SET_ELEMENT_DATA", dataKey: dataBindStr, value: prmData })


        //comment - not for now
        // APPLYOO.internals.raiseEvent(APPLYOO.globals.eventTypes.pageDataChanged.EventCode, dataBindStr);
    }

    static getDataItem(prmDataBindStr: any) {
        let outVal;
        if (!!prmDataBindStr && prmDataBindStr.startsWith("FreeBinding.")) {
            prmDataBindStr = prmDataBindStr.substring("FreeBinding.".length);
        }

        if (!!prmDataBindStr && prmDataBindStr.length > 0) {
            let currPageData = store.getState().store_PageData.data;

            if (prmDataBindStr.endsWith(".[RowsCount]")) {
                let nestedDataObj = dataUtils.getNestedJsonValue(currPageData, prmDataBindStr.substring(0, prmDataBindStr.length - ".[RowsCount]".length));

                if (!!nestedDataObj) {
                    outVal = nestedDataObj.length;
                } else {
                    outVal = 0;
                }
            } else if (Object.keys(currPageData).length > 0) {
                outVal = dataUtils.getNestedJsonValue(currPageData, prmDataBindStr);
            }
        }
        // if (outVal) {
        //     outVal = cloneDeep(outVal)
        // }
        return outVal;
    }

    static getRelatedParamsForValue(prmExpression: any, prmElementObj?: any) {

        let outStr = prmExpression;

        if (prmExpression != undefined
            && prmExpression != null
            && dataUtils.isString(prmExpression)) {

            let lastIndexOfParam_End = 0;

            let currWorkingStr = outStr;

            while (!!currWorkingStr
                && currWorkingStr.indexOf("[@") >= 0) {

                let indexOfParam_Start = currWorkingStr.indexOf("[@")

                if (indexOfParam_Start >= 0) {

                    let currParamExpressionStr = currWorkingStr.substring(indexOfParam_Start);

                    let indexOfParam_End = currParamExpressionStr.indexOf("]");

                    if (indexOfParam_End >= 0) {

                        currParamExpressionStr = currParamExpressionStr.substring(0, indexOfParam_End + 1);

                        let currExpressionNoBrackets = currParamExpressionStr.replaceAll("[", "");
                        currExpressionNoBrackets = currExpressionNoBrackets.replaceAll("]", "");

                        if (currExpressionNoBrackets.indexOf("@Data.") >= 0) {

                            let dataBindStr = currExpressionNoBrackets.substring("@Data.".length);

                            let arrDataBindStrParts = dataBindStr.split(".");

                            if (!!prmElementObj
                                && !!prmElementObj.temp
                                && prmElementObj.temp.rowDataObj) {

                                let dataBindObject = dataUtils.getDataBindObject(prmElementObj, dataBindStr);

                                if (!!dataBindObject) {

                                    let dataBindFieldName = arrDataBindStrParts[2];

                                    if (!!dataBindFieldName) {

                                        // @ts-ignore
                                        let currValue = dataBindObject[dataBindFieldName];
                                        outStr = outStr.replaceAll(currParamExpressionStr, currValue);
                                    }

                                }
                            } else {

                                let currValue = utils_ui.getDataItem(dataBindStr);
                                outStr = outStr.replaceAll(currParamExpressionStr, currValue);
                            }


                        }

                        //[@LangKey.View]

                        // else if (currExpressionNoBrackets.indexOf("@LangKey.") >= 0) {
                        //
                        //     let langKey = currExpressionNoBrackets.substring("@LangKey.".length);
                        //     let currValue = APPLYOO.globalizationUtils.getLanguageText(langKey);
                        //     outStr = outStr.replaceAll(currParamExpressionStr, currValue);
                        //
                        // }

                        else if (currExpressionNoBrackets.indexOf("@URL.") >= 0) {

                            let fieldname = currExpressionNoBrackets.substring("@URL.".length);
                            //comment : todo
                            // let currValue = APPLYOO.selectedPage.urlParams[fieldname];
                            // outStr = outStr.replaceAll(currParamExpressionStr, currValue);
                        } else if (currParamExpressionStr.indexOf("[@Eval]") >= 0) {

                            let exp = currWorkingStr.substring("[@Eval].".length);

                            try {
                                outStr = eval(exp);
                            } catch (e) {
                                console.log("Unable to evaluate designer expression", e);
                            }

                        } else if (currExpressionNoBrackets.indexOf("@User.") >= 0) {

                            let fieldname = currExpressionNoBrackets.substring("@User.".length);

                            let currValue = store.getState().store_userData.userDetailsObj?.userDetials[fieldname];
                            outStr = outStr.replaceAll(currParamExpressionStr, currValue);
                        } else if (currExpressionNoBrackets.indexOf("@PrimaryEntityID") >= 0) {
                            let currPrimaryEntityID = store.getState().store_PageData.primaryEntityID;
                            outStr = outStr.replaceAll(currParamExpressionStr, currPrimaryEntityID);
                        } else if (currExpressionNoBrackets.indexOf("@Project.") >= 0) {

                            let fieldname = currExpressionNoBrackets.substring("@Project.".length);

                            let currValue = store.getState().store_ProjectData.selectedProject?.Project[fieldname];
                            outStr = outStr.replaceAll(currParamExpressionStr, currValue);
                        } else if (currExpressionNoBrackets.indexOf("@Variable.") >= 0) {

                            let paramName = currExpressionNoBrackets.substring("@Variable.".length);

                            let currParameterObj = store.getState().store_ProjectData.dicProjectParameters[paramName]

                            if (!currParameterObj) {
                                console.warn("!!!Applyoo Warning: the Parameter: '" + paramName + "' (" + currParamExpressionStr + ") not exist in ProjectParameters");
                            } else if (!!currParameterObj
                                && !!currParameterObj.ParamName
                                && (!currParameterObj.PageID || currParameterObj.PageID === store.getState().store_PageStructure?.pageCode)) {

                                let currValue = dataUtils.parseValueByDataType(currParameterObj.DataType, currParameterObj.ActualValue);
                                outStr = outStr.replaceAll(currParamExpressionStr, currValue);
                            }
                        }
                    }


                    currWorkingStr = currWorkingStr.substring(indexOfParam_Start + 2);

                }
            }
        }


        return outStr;
    }

    static validate(prmQueryName?: string): [] {
        let isValid: boolean = true;

        //let currPageStruct = store.getState().store_PageStructure()
        let lstValidationErrors: any = [];
        let currPageStruct = store.getState().store_PageStructure; //.pageStructure;

        let validationObj = new ValidationManager();
        let lstValidateElements:any = []

        for (const currElementGuid in currPageStruct.dicElementsFlatTree) {
            let currElementObj = currPageStruct.dicElementsFlatTree[currElementGuid]?.ElementObj

            if (!!currElementObj?.DataBindStr
                && (!prmQueryName || currElementObj.DataBindStr?.startsWith(prmQueryName))) {
                lstValidateElements.push(currPageStruct.dicElementsFlatTree[currElementGuid])
            }
        }


        // let lstValidateElements = currPageStruct.lstElementsFlat.filter((prmElement: any) => {
        //     return !!prmElement.ElementObj.DataBindStr
        //         && (!prmQueryName || prmElement.ElementObj.DataBindStr.startsWith(prmQueryName));
        // });

        if (lstValidateElements.length > 0 && validationObj.lstValidations) {
            for (let ind01 = 0; ind01 < lstValidateElements.length; ind01++) {
                const currElementObj = lstValidateElements[ind01];

                if (currElementObj?.ElementObj?.ExtendedParamsObj?.Validations) {
                    validationObj.lstValidations?.map((validationInstance:any) => {
                        if (!!validationInstance.Validate) {
                            let validationResult:any = validationInstance.Validate(currElementObj.ElementObj);

                            if (validationResult.isError) {
                                validationResult.ElementGuid = currElementObj.ElementGuid;
                                validationResult.ElementObj = currElementObj.ElementObj;
                                //validationResult.ValidationType = validationInstance.validateCode;

                                lstValidationErrors.push(validationResult)
                                isValid = false;
                            }
                            //isValid = isValid && validationInstance.Validate(currElementObj.ElementObj).isError
                        }
                    })
                }


                //currPageStruct.dicElementsFlatTree["UI_Textbox_8c8e60f8-46df-498f-a8bb-9b7f3d9f2dd7"].ElementObj.ExtendedParamsObj.Validations

                // const currValidationInstance = this.dicValidation[currValidationObj.validateCode];
                //
                // if (currValidationInstance){
                //     currValidationInstance.Validate(prmElementObj)
                // }
            }
        }


        return lstValidationErrors;
    }

    static isObjEmpty = (prmObj: any) => {
        let outVal = true;

        if (prmObj) {
            outVal = Object.keys(prmObj).length === 0

            if (outVal){
                if(Array.isArray(prmObj) == true){
                    outVal = false ;
                }
            }
        }
        return outVal
    }

    static parseFontIcon(prmIconStr: string, prmDefaultIconStr?: string) {
        // if(prmIconStr.includes('tachometer')){
        // }
        //let outVal: IconProp;


        let iconStr: string = "";
        if (!!prmIconStr) {
            iconStr = prmIconStr
                .replace('fa ', '')
                .replace('fa-', '')
                .replace('fa-rotate-180', '')

            // .substr(prmIconStr.indexOf("-") + 1);

            let startIndex = iconStr?.indexOf(".")
            if (startIndex) {
                iconStr = iconStr.substr(startIndex + 1).replace(']', "")
            }

            if (iconStr.endsWith("-o")) {
                iconStr = iconStr.substr(0, iconStr.length - 2);
            }

            if (!!this.dicOldFontIcons[iconStr]) {
                iconStr = this.dicOldFontIcons[iconStr];
            }
        }

        if (!iconStr && !!prmDefaultIconStr) {
            iconStr = prmDefaultIconStr;
        }
        else if (!iconStr && !prmDefaultIconStr) {
            iconStr = 'minus';
        }

        if (!!iconStr) {
            iconStr = iconStr.trim();
        }

        return iconStr; // as IconProp;
    }


    static parseApplyooIcon(prmIconStr: string, prmDefaultIconStr?: string) {
        //let outVal: IconProp;

        let iconStr: string = "";
        if (!!prmIconStr) {
            iconStr = prmIconStr

            if (iconStr.indexOf("fa-") == -1) {
                iconStr = 'fa-' + iconStr
            }

            if (iconStr.includes("fa ")) {
                iconStr = iconStr.replace('fa ', '');
            }



            // .replace('fa ', '')
            // .replace('fa-', '')
            // .replace('fa-rotate-180', '')

            // .substr(prmIconStr.indexOf("-") + 1);

            let startIndex = iconStr?.indexOf(".")
            if (startIndex) {
                iconStr = iconStr.substr(startIndex + 1).replace(']', "")
            }

            if (iconStr.endsWith("-o")) {
                iconStr = iconStr.substr(0, iconStr.length - 2);
            }

            if (!!this.dicNewFontIcons[iconStr]) {
                iconStr = this.dicNewFontIcons[iconStr];
            }
        }

        if (!iconStr && !!prmDefaultIconStr) {
            iconStr = prmDefaultIconStr;
        }
        else if (!iconStr && !prmDefaultIconStr) {
            iconStr = 'fa-minus';
        }

        if (!!iconStr) {
            iconStr = iconStr.trim();
        }

        if (iconStr.indexOf("fa-solid") == -1) {
            iconStr = 'fa-solid ' + iconStr
        }

        return iconStr; // as IconProp;
    }

    static GetFieldFormat(prmFormatStr: string,prmFormatTypeStr?: string): string {
        let outVal = prmFormatStr || "";

        if (!!outVal) {
            outVal = outVal.toString().replaceAll("{0:", "");
            outVal = outVal.toString().replaceAll("{", "");
            outVal = outVal.toString().replaceAll("}", "");
        }

        if (prmFormatTypeStr == "number" && outVal == "") {
            outVal = "0"
        }

        return outVal;
    }
    static createNewDefaultElement(prmElementTypeObj: any): any {
        //ToDo : consult with yuval

    }

    static getDistinctListFromSeperatedString = (prmStr: string, prmSeperator: string) => {
        let itemKey: any = new Set(prmStr?.split(prmSeperator));
        let lstOut = Array.from(itemKey);

        return lstOut;
    }

    static getLocalStorageItem = (prmKey: string, prmIsParse: boolean) => {
        let outVal = localStorage.getItem(prmKey);

        if (!!outVal && prmIsParse) {
            try {
                outVal = dataUtils.parseData(outVal);
            }
            catch (e) {
                //DO NOTHING
            }

        }

        if (!outVal){
            outVal = "";
        }

        return outVal
    }

    static setLocalStorageItem = (prmKey: string, prmValue: any, prmIsStringify: boolean) => {
        if (prmIsStringify) {
            const strValue = JSON.stringify(prmValue);
            localStorage.setItem(prmKey, strValue)
        }
        else {
            localStorage.setItem(prmKey, prmValue)
        }
    }

    static removeLocalStorageItem = (prmKey: string) => {
        if (!!localStorage[prmKey]){
            localStorage.removeItem(prmKey)
        }
    }

    static GetUsersToDropDownElement(prmLstUserIDs: any, prmIsAddNullOption?: boolean): any[] {
        let outVal: any[] = []
        //let lstAllUsers = store.getState().store_Repositories?.dicRepositoryItems?.virtualList_MyRelatedUsers
        let lstAllUsers = store.getState().store_Repositories?.dicRepositoryItems?.tb_Users

        if (!lstAllUsers){
            lstAllUsers = store.getState().store_Repositories?.dicRepositoryItems?.tb_Users
        }

        let dicUsers: any = {}

        if (lstAllUsers) {
            dicUsers = dataUtils.convertArrayToDicObject(lstAllUsers, 'UserID')
            if (prmIsAddNullOption) {
                let nullOption = {
                    value: null,
                    label: utils_ui.getLanguageTitle(dataUtils.parseLangKey("UI_ComboBox_Select"))
                }
                outVal.push(nullOption)
            }
            for (const currUserID of prmLstUserIDs) {
                let currUserObj = dicUsers[currUserID];

                if (currUserObj) {
                    let currDisplayUserDetails = {
                        id: currUserObj.UserID,
                        value: currUserObj.UserID,
                        text:currUserObj.DisplayName,
                        label: <div className="d-flex drop-down align-items-center">
                            <div className='mr-50 ml-50 avatar'>
                                {currUserObj?.ImageUrl ?
                                    <img className='image-in-drop-down-list img-fluid img-user-sm'
                                        loading="lazy"
                                        src={`${utils_ui.getBaseFilesUrl()}${currUserObj?.ImageUrl}`} />
                                    :
                                    <UI_ApplyooAvatar title={currUserObj.DisplayName} initials={true} />
                                }
                            </div>
                            {currUserObj.DisplayName}
                        </div>,
                        img: <div className='avatar img-user-sm'>`${utils_ui.getBaseFilesUrl()}${currUserObj?.ImageUrl}`</div>,
                        imgSource: `${utils_ui.getBaseFilesUrl()}${currUserObj?.ImageUrl}`,
                        userObj: currUserObj,
                    }
                    outVal.push(currDisplayUserDetails)
                }
            }

        }
        return outVal;
    }

    static GetAllUsersForDropDownElement(prmIsAddNullOption?: boolean): any[] {
        let lstOut =[];
        let lstAllUsers = store.getState().store_Repositories?.dicRepositoryItems?.tb_Users

        if (!!lstAllUsers){
            let lstAllUsersIDs = lstAllUsers.map((prmItem:any)=>{
                return prmItem.UserID
            })
            lstOut = utils_ui.getUsersToDropDownElementFrom_tb_users(lstAllUsersIDs,prmIsAddNullOption)
        }

        return lstOut;
    }

    static FormatNumberIfNeeded(prmValue:any, prmFormatStr:any) {
        let value = prmValue;
        let outVal = value;

        try {
            if (value) {
                value = Number(value);

                if (utils_ui.isNumericValue(value)) {
                    outVal = utils_ui.FormatNumber(value, prmFormatStr)
                }
            }
        }
        catch (e) {}

        return outVal
    }

    //https://stackoverflow.com/questions/2901102/how-to-format-a-number-with-commas-as-thousands-separators
    static FormatNumber(prmNumber:any, prmFormatStr:any) {
        let outVal = prmNumber
        let thousands_sign = ","
        let decimalPoint_sign = "."
        let numDecimalPoints = 0

        if (prmFormatStr.indexOf(",")) {
            thousands_sign = ","
        }
        else {
            thousands_sign = ""
        }

        if (prmFormatStr.lastIndexOf(".") > -1) {
            numDecimalPoints = Math.abs((prmFormatStr.length-1) - prmFormatStr.lastIndexOf("."))
        }

        if (!!prmNumber) {
            let arrNumberParts:any = []

            if (!!numDecimalPoints) {
                let roundBy = Math.pow(10, numDecimalPoints);
                let fixedNum = Math.round(prmNumber * roundBy) / roundBy
                arrNumberParts = fixedNum.toString().split('.')
            }
            else {
                arrNumberParts = Math.round(prmNumber).toString().split('.')
            }


            if (arrNumberParts[0].length > 3) {
                arrNumberParts[0] = arrNumberParts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, thousands_sign);
            }

            if ((arrNumberParts[1] || '').length < numDecimalPoints) {
                arrNumberParts[1] = arrNumberParts[1] || '';
                arrNumberParts[1] += new Array(numDecimalPoints - arrNumberParts[1].length + 1).join('0');
            }

            outVal = arrNumberParts.join(decimalPoint_sign);
        }

        return outVal
    }

    static GetUsersForDropDownElement(prmLstUserIDs:[number], prmIsAddNullOption?: boolean): any[] {
        let lstOut =[];
        lstOut = utils_ui.getUsersToDropDownElementFrom_tb_users(prmLstUserIDs,prmIsAddNullOption)

        return lstOut;
    }

    static createStrToListForSelectBox = (prmStr:any) =>{
        let lstOut:any = [];

        if (!!prmStr) {
            let lstData = prmStr?.split(',')

            for (const currItem of lstData) {
                let uiObj = {
                    value: currItem,
                    text: utils_ui.getLanguageTitle(currItem),
                    label: <div>{utils_ui.getLanguageTitle(currItem)}</div>
                }

                lstOut.push(uiObj)
            }
        }

        return lstOut;
    }

    static createListForSelectBox = (prmList:any , prmKeyField:string ,prmTextField:string) =>{
        let lstOut:any = [];

        if (!!prmList) {
            for (const currItem of prmList) {
                let uiObj = {
                    value: currItem[prmKeyField],
                    text: utils_ui.getLanguageTitle(currItem[prmTextField]),
                    label: <div>{utils_ui.getLanguageTitle(currItem[prmTextField])}</div>
                }

                lstOut.push(uiObj)
            }
        }
      
        return lstOut;
    }

    static createListWithAvatarForSelectBox = (prmList:any , prmKeyField:string ,prmTextField:string,prmImgField:string) =>{
        let lstOut:any = [];

        if (!!prmList) {
            for (const currItem of prmList) {
                let uiObj = {
                    value: currItem[prmKeyField],
                    text: utils_ui.getLanguageTitle(currItem[prmTextField]),
                    label: <div>{utils_ui.getLanguageTitle(currItem[prmTextField])}</div>,
                    imageUrl:currItem[prmImgField]
                }

                lstOut.push(uiObj)
            }
        }

        return lstOut;
    }

    static getUsersToDropDownElementFrom_tb_users(prmLstUserIDs: any, prmIsAddNullOption?: boolean): any[] {
        let outVal: any[] = []
        let lstAllUsers = store.getState().store_Repositories?.dicRepositoryItems?.tb_Users
        let dicUsers: any = {}

        if (lstAllUsers) {
            dicUsers = dataUtils.convertArrayToDicObject(lstAllUsers, 'UserID')
            if (prmIsAddNullOption) {
                let nullOption = {
                    value: null,
                    label: utils_ui.getLanguageTitle(dataUtils.parseLangKey("UI_ComboBox_Select"))
                }
                outVal.push(nullOption)
            }
            for (const currUserID of prmLstUserIDs) {
                let currUserObj = dicUsers[currUserID];

                if (currUserObj) {
                    let currDisplayUserDetails = {
                        id: currUserObj.UserID,
                        text:currUserObj.DisplayName,
                        value: currUserObj.UserID,
                        label: <div className="d-flex drop-down align-items-center">
                            <div className='mr-50 ml-50 avatar'>
                                {currUserObj?.ImageUrl ?
                                    <img className='image-in-drop-down-list img-fluid img-user-sm'
                                        loading="lazy"
                                        src={`${utils_ui.getBaseFilesUrl()}${currUserObj?.ImageUrl}`} />
                                    :
                                    <UI_ApplyooIcon iconStr="circle" />
                                }
                            </div>
                            {currUserObj.DisplayName}
                        </div>,
                        img: <div className='avatar img-user-sm'>`${utils_ui.getBaseFilesUrl()}${currUserObj?.ImageUrl}`</div>,
                        imgSource: `${utils_ui.getBaseFilesUrl()}${currUserObj?.ImageUrl}`,
                        userObj: currUserObj,
                    }
                    outVal.push(currDisplayUserDetails)
                }
            }

        }
        return outVal;
    }

    static filterOptionInReactSelect = (prmOption:any, prmInputValue:any , prmList:any , prmByField:any) => {
        const { label, value ,data} = prmOption;
        let isContainsKey = false

        // looking if other options with same label are matching inputValue
        const lstOtherKeys =  prmList?.filter((prmItem:any) => {
            return !!prmItem
                && !!prmItem[prmByField]
                && !!data
                && !!data[prmByField]
                && prmItem[prmByField]?.toString().toLowerCase() == data[prmByField]?.toString().toLowerCase()
                    &&  prmItem[prmByField]?.toString().toLowerCase()?.includes(prmInputValue?.toString().toLowerCase());
        })

        isContainsKey = (lstOtherKeys?.length > 0)
        return  isContainsKey;
    };

    static convertStringToBase64(prmStr:any) {
        let outVal = btoa(prmStr)

        return outVal
        // return btoa(encodeURIComponent(prmStr).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        //     return String.fromCharCode('0x' + p1);
        // }));
    }

    static convertBase64ToString(prmStr:any) {
        let outVal = atob(prmStr)

        return outVal
        // return btoa(encodeURIComponent(prmStr).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        //     return String.fromCharCode('0x' + p1);
        // }));
    }

    static ParseDataParams(prmObj:any) {
        if (!!prmObj) {
            for (const currKey in prmObj) {
                if (!!prmObj[currKey]
                        && prmObj[currKey].toString().startsWith("[@")) {
                    let currVal = utils_ui.GetParamValue(prmObj[currKey])
                    prmObj[currKey] = currVal
                }
            }
        }
    }

    static GetParamValue(prmParamStr: string) {
        let outVal = prmParamStr;

        while (!!outVal
            && outVal.indexOf("[@") >= 0) {

            let indexOfParam_Start = outVal.indexOf("[@")

            if (indexOfParam_Start >= 0) {

                let currParamExpressionStr = outVal.substring(indexOfParam_Start);

                let indexOfParam_End = currParamExpressionStr.indexOf("]");

                if (indexOfParam_End >= 0) {

                    currParamExpressionStr = currParamExpressionStr.substring(0, indexOfParam_End + 1);

                    let currExpressionNoBrackets = currParamExpressionStr.replaceAll("[", "");
                    currExpressionNoBrackets = currExpressionNoBrackets.replaceAll("]", "");

                    if (currExpressionNoBrackets.indexOf("@Data.") >= 0) {

                        let dataBindStr = currExpressionNoBrackets.substring("@Data.".length);

                        let arrDataBindStrParts = dataBindStr.split(".");

                        let currValue = utils_ui.getDataItem(dataBindStr); //APPLYOO.utils.getDataItem(dataBindStr, APPLYOO.runtimeUtils.scopeObj);
                        outVal = outVal.replaceAll(currParamExpressionStr, currValue);

                        // if (!!prmElementObj
                        //     && !!prmElementObj.temp
                        //     && prmElementObj.temp.rowDataObj) {
                        //
                        //     let dataBindObject = APPLYOO.runtimeUtils.getDataBindObject(prmElementObj, dataBindStr);
                        //
                        //     if (!!dataBindObject) {
                        //
                        //         let dataBindFieldName = arrDataBindStrParts[2];
                        //
                        //         if (!!dataBindFieldName) {
                        //
                        //             let currValue = dataBindObject[dataBindFieldName];
                        //             outStr = outStr.replaceAll(currParamExpressionStr, currValue);
                        //         }
                        //
                        //     }
                        // }
                        // else {
                        //
                        //     let currValue = APPLYOO.utils.getDataItem(dataBindStr, APPLYOO.runtimeUtils.scopeObj);
                        //     outStr = outStr.replaceAll(currParamExpressionStr, currValue);
                        // }


                    }

                    //[@LangKey.View]

                    else if (currExpressionNoBrackets.indexOf("@LangKey.") >= 0) {
                        //&& !!APPLYOO.runtimeUtils.rootScopeObj.CurrentLanguageSet) {

                        let langKey = currExpressionNoBrackets.substring("@LangKey.".length);
                        // let currValue = APPLYOO.globalizationUtils.getLanguageText(langKey);
                        // outStr = outStr.replaceAll(currParamExpressionStr, currValue);

                    } else if (currExpressionNoBrackets.indexOf("@URL.") >= 0) {

                        let fieldname = currExpressionNoBrackets.substring("@URL.".length);

                        let currValue = ""; //APPLYOO.selectedPage.urlParams[fieldname];
                        outVal = outVal.replaceAll(currParamExpressionStr, currValue);
                    } else if (currParamExpressionStr.indexOf("[@Eval]") >= 0) {

                        let exp = outVal.substring("[@Eval].".length);

                        try {
                            outVal = eval(exp);
                        } catch (e) {
                            console.log("Unable to evaluate designer expression", e);
                        }

                    } else if (currExpressionNoBrackets.indexOf("@User.") >= 0) {

                        let fieldname = currExpressionNoBrackets.substring("@User.".length);

                        let currValue = ""; //APPLYOO.userObj.userDetials[fieldname];
                        outVal = outVal.replaceAll(currParamExpressionStr, currValue);
                    } else if (currExpressionNoBrackets.indexOf("@Project.") >= 0) {

                        let fieldname = currExpressionNoBrackets.substring("@Project.".length);

                        let currValue = ""; //APPLYOO.selectedProject[fieldname];
                        outVal = outVal.replaceAll(currParamExpressionStr, currValue);
                    } else if (currExpressionNoBrackets.indexOf("@Variable.") >= 0) {

                        let paramName = currExpressionNoBrackets.substring("@Variable.".length);

                        // let currPrameterObj = APPLYOO.runtimeUtils.rootScopeObj.dicProjectParameters[paramName];
                        //
                        // if (!currPrameterObj) {
                        //     console.warn("!!!Applyoo Warning: the Parameter: '" + paramName + "' (" + currParamExpressionStr + ") not exist in ProjectParameters");
                        // }
                        // else if (!!currPrameterObj
                        //     && !!currPrameterObj.ParamName
                        //     && (!currPrameterObj.PageID || currPrameterObj.PageID == APPLYOO.selectedProject.selectedPageID)) {
                        //
                        //     let currValue = ""; //APPLYOO.runtimeUtils.parseValueByDataType(currPrameterObj.DataType, currPrameterObj.ActualValue);
                        //     outVal = outVal.replaceAll(currParamExpressionStr, currValue);
                        // }
                    } else if (currParamExpressionStr.indexOf("@System.") >= 0) {
                    }

                    // else if (currParamExpressionStr.indexOf(APPLYOO.formulaUtils.formulaPrefix) >= 0) {
                    //     let currValue = APPLYOO.formulaUtils.calcFormulaFunction(currParamExpressionStr, prmElementObj);
                    //     outStr = outStr.replaceAll(currParamExpressionStr, currValue);
                    // }
                }


                //outVal = outVal.substring(indexOfParam_Start + 2);

            }
        }

        return outVal;
    }


    static async GetNewEntityDefaults(prmPageStructure: any, prmElementObj: any, prmEntityName?: any) {
        let paramsObj = {
            "ProjectID": prmPageStructure.pageStructure.ProjectID,
            "DataConnectionCode": "",
            "EntityName": ""
        }

        let entityName = "";
        let dataConnectionCode = "";
        let queryName = "";

        if (!!prmPageStructure && !!prmElementObj && prmElementObj.DataBindStr) {
            let arrDataBind = prmElementObj.DataBindStr.split(".");

            if (arrDataBind.length >= 2) {
                queryName = arrDataBind[0];
                entityName = arrDataBind[arrDataBind.length - 1];



                // if (!!queryObj) {
                //     paramsObj.DataConnectionCode = queryObj[0].DataConnectionCode;
                //     paramsObj.EntityName = entityName;
                //
                //     let resp = await callPostService("clsSvcEntities_GetNewEntityDefaults", paramsObj).then((prmResponse: any) => {
                //         if (!!prmResponse?.reponseObj?.DicDefaultValues) {
                //             return prmResponse?.reponseObj?.DicDefaultValues;
                //         } else {
                //             return {};
                //         }
                //     })
                //
                //     let data = await resp;
                //     return data;
                // }

            }
            else if (!!prmEntityName && arrDataBind.length > 0) {
                queryName = arrDataBind[0];
                entityName = prmEntityName;
            }

            if (!!entityName && !!queryName) {
                let queryObj = prmPageStructure.pageStructure.LstDataRequests.filter((currQry: any) => {
                    return currQry.ResponseName == queryName
                })[0];

                paramsObj.EntityName = entityName;
                paramsObj.DataConnectionCode = queryObj?.DataConnectionCode;
                //paramsObj.DataConnectionCode = queryObj[0].DataConnectionCode;
                //paramsObj.EntityName = entityName;

                let resp = await callPostService("clsSvcEntities_GetNewEntityDefaults", paramsObj).then((prmResponse: any) => {

                    if (!!prmResponse?.reponseObj?.DicDefaultValues) {
                        return prmResponse?.reponseObj?.DicDefaultValues;
                    } else {
                        return {};
                    }
                })

                let data = await resp;
                return data;
            }
        }

    }

    static removeDoubleSlashFromUrl(prmUrlStr: any){
        let outVal = prmUrlStr;

        if (!!outVal){
            let protocolStrIndex = outVal.indexOf("://")
            let minStartIndex=0;

            if (protocolStrIndex > -1) {
                minStartIndex = protocolStrIndex + 3;
            }

            if (minStartIndex > 0)
            {
                outVal = outVal.substring(0,minStartIndex) + outVal.substring(minStartIndex).replaceAll("//","/")
            }
            else {
                outVal = outVal.replaceAll("//","/")
            }
        }

        return outVal;
    }

    static parseDateStrFromDDMMYY(prmValue:any) {
        let outDT = prmValue

        if (!!prmValue && typeof prmValue === "string") {
            if (prmValue.includes('T')) {
                // Handle ISO format
                outDT = new Date(prmValue);
            } else {
                // Handle "DD/MM/YYYY" or "DD-MM-YYYY" or "DD.MM.YYYY"
                const [day, month, year] = prmValue.split(/[\/.-]/);
                if (year && month && day) {
                    outDT = new Date(`${year}-${month}-${day}`);
                }
            }
        }

        return outDT
    }

    static convertDisplayFormatToApplyooReact(prmFormat: any): string {
        let outVal = prmFormat;

        if (!!prmFormat) {
            switch (prmFormat) {
                case 'n0':
                case '0':
                    outVal = '#,##0;-#,##0'
                    break;

                case 'n2':
                case '2':
                    outVal = '#,##0.00;-#,##0.00'
                    break;

                case 'n3':
                    outVal = '#,##0.000;-#,##0.000'
                    break;

                case 'n4':
                case '4':
                    outVal = '#,##0.0000;-#,##0.0000'
                    break;

                case 'removeLeadingZeroes':
                    outVal = '#0'
                    break;

                case 'p0':
                case 'P0':
                    outVal = '#,##0%;-#,##0%'
                    break;

                case 'p2':
                case 'P2':
                    outVal = '#,##0.00%;-#,##0.00%'
                    break;

            }
        }

        return outVal
    }

    static getBooleanDisplayText = (prmBool:boolean) => {
        let outStr = utils_ui.getLanguageTitle('Title_No')

        if(!!prmBool)
        {
            outStr = utils_ui.getLanguageTitle('Title_Yes')
        }

        return outStr;
    }

    static isContentOverflowing(prmIsSelectionByID:string, prmSelectionStr:string)
    {
        let isOverflowing = false;
        let divElement:any = null;

        if (!!prmIsSelectionByID) {
            divElement = document.getElementById(prmSelectionStr);
        }
        else {
            let arrItems:any = document.getElementsByClassName(prmSelectionStr);

            if (arrItems?.length > 0) {
                divElement = arrItems[0]
            }
        }

        if (!!divElement) {
            isOverflowing = divElement.scrollHeight > divElement.clientHeight || divElement.scrollWidth > divElement.clientWidth;
        }

        return isOverflowing
    }

    static getUserAvatar = (prmUserID:any) => {
        let outJsx = <></>
        const arrUsersStore = store.getState().store_Repositories.dicRepositoryItemsForKeyValue['tb_Users'];
        let currUser = arrUsersStore?.find((prmItem:any) => prmItem.value == prmUserID);

        if (!!currUser) {
            outJsx = <div className="d-flex mx-50">
                {
                    currUser?.row?.ImageUrl?
                        <UI_ApplyooAvatar ImageUrl={ currUser?.row?.ImageUrl}
                                          title={ currUser?.row?.DisplayName}
                                          size='xs'
                                          initials={false} />:
                        <UI_ApplyooAvatar title={ currUser?.row?.DisplayName}
                                          size='xs'
                                          initials={true} />
                }
                {/* <Avatar  //@ts-ignore
                                                img={prmUser?.metadata?.ImageUrl} /> */}
                <div className='align-self-center ml-25'>{ currUser?.row?.DisplayName}</div>
            </div>
        }

        return outJsx
    }

    static downloadFileByUrl = (prmFileUrl: string) => {
        window.open(`${prmFileUrl}`, "_blank");
    }

    static chkNullNum = (prmValue: any) => {
        let outVal:number = 0

        if (!!prmValue) {
            outVal = prmValue
        }

        return outVal
    }

    static chkNullStr = (prmValue: any) => {
        let outVal:string = ''

        if (!!prmValue) {
            outVal = prmValue
        }

        return outVal
    }
}